import {callApi} from '@/api/apibase'

export const createOrder = function (locationId, productId, greenCourseId) {
    const requestData = {
        locationId: locationId,
        productId: productId,
        greenCourseId: greenCourseId,
    }
    return callApi( 'POST','/api/shop/externalsystem/order/createFromExternalGreenCoursePortal', requestData)
}

